import React, { useState } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { ReactComponent as Hide } from "../../../../assets/images/hide.svg";
import { ReactComponent as Unhide } from "../../../../assets/images/unhide.svg";
import { errorTextSx, inputLabelSx, textFieldSx } from "../shared/styles";

function PasswordInput({ label, placeholder, value, onChange, error }) {
  const [show, setShow] = useState(false);

  return (
    <Box sx={{ mb: "16px" }}>
      <Typography component="label" sx={inputLabelSx} >
        {label}
      </Typography>
      <Box sx={{ position: "relative" }}>
        <TextField
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete="off"
          fullWidth
          sx={{
            ...textFieldSx,
            marginTop: '8px',
            "& .MuiOutlinedInput-root": {
              ...textFieldSx["& .MuiOutlinedInput-root"],
              pr: "40px",
            },
          }}
        />
        <IconButton
          type="button"
          onClick={() => setShow((prev) => !prev)}
          aria-label={show ? "Hide password" : "Show password"}
          sx={{
            position: "absolute",
            right: "12px",
            top: "56%",
            transform: "translateY(-50%)",
            p: 0,
          }}
        >
          {show ? <Unhide /> : <Hide />}
        </IconButton>
      </Box>
      {error ? (
        <Typography component="p" sx={errorTextSx}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}

export default PasswordInput;
